import React from 'react';
import './App.css';
import Router from './Router';
import ModalDisplayer from './components/ModalDisplayer';
import BottomBar from './utils/BottomBar';
import {Tooltip} from "react-tooltip";

function App() {
  return (
    <>
      <Router/>
      <ModalDisplayer/> {/* modal dialog boxes) depending on the current action specified in the application context */}
      <BottomBar /> {/* Bottom notification bar - hidden by default - display message when they are something to notice */}
      <Tooltip
        id="main-tooltip"
        style={{fontSize: "0.75rem", zIndex: 9999}}
        place='left'
      />
      <Tooltip
        id="main-tooltip-right"
        style={{fontSize: "0.75rem", zIndex: 9999}}
        place='right'
      />
      <Tooltip
        id="main-tooltip-top"
        style={{fontSize: "0.75rem", zIndex: 9999}}
        place='top'
      />
    </>
  );
}

export default App;
